import type { SVGProps } from 'react';

export const TripAdvisorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 10' fill='none' {...props}>
    <path
      fill='black'
      d='m14.302 2.912 1.273-1.384h-2.823A8.764 8.764 0 0 0 7.786 0 8.742 8.742 0 0 0 2.83 1.528H0l1.273 1.384a3.891 3.891 0 1 0 5.267 5.73L7.786 10l1.248-1.357a3.892 3.892 0 1 0 5.268-5.73ZM3.895 8.422a2.633 2.633 0 1 1 0-5.266 2.633 2.633 0 0 1 0 5.266Zm3.893-2.71c0-1.733-1.26-3.22-2.924-3.856a7.555 7.555 0 0 1 2.922-.584c1.037 0 2.024.209 2.923.585-1.661.636-2.921 2.123-2.921 3.855Zm3.89 2.71a2.633 2.633 0 1 1 0-5.266 2.633 2.633 0 0 1 0 5.266Zm0-4.015a1.38 1.38 0 1 0-.064 2.76 1.38 1.38 0 0 0 .064-2.76ZM5.276 5.788a1.38 1.38 0 1 1-2.76 0 1.38 1.38 0 0 1 2.76 0Z'
    />
  </svg>
);
